export default __webpack_public_path__ + "static/media/meals.07f11685.jpg";